Vue.component("backButton", {
    props: ["settings"],
    template: `
        <transition name="hotspotEntranceLeft">
            <div class="button__back button" v-if="buttonReady && !isHome" @click="back">
                <span>Tilbage</span>
            </div>
        </transition>
    `,
    data() {
        return {
            buttonReady: false
        }
    },
    mounted() {
        // intro animation when scene is ready.
        this.buttonReady = true;
    },
    methods: {
        back() {
          app.router.back();
        },
    },
    computed: {
        isHome() {
            return this.$route.path === app.router.defaultRoute;
        }
    },
})